import { render, staticRenderFns } from "./ModulesVideo.vue?vue&type=template&id=3344b676"
import script from "./ModulesVideo.vue?vue&type=script&lang=js"
export * from "./ModulesVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicVideo: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicVideo.vue').default})
